export default "__VITE_ASSET__BCuJPpot__"